import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VisaCountry, VisaSelect } from '../Core/visa.data';

@Injectable({
  providedIn: 'root',
})
export class VisaService {
  private visaCountrySubject = new BehaviorSubject<VisaCountry>(
    {} as VisaCountry
  );
  visaCountry$ = this.visaCountrySubject.asObservable();

  setVisaCountry(visaCountry: VisaCountry) {
    this.visaCountrySubject.next(visaCountry);
  }
  getVisaCountry(): VisaCountry {
    return this.visaCountrySubject.getValue();
  }
  //========================================
  private visaTypeSubject = new BehaviorSubject<VisaSelect>({} as VisaSelect);
  visaType$ = this.visaTypeSubject.asObservable();

  setVisaType(visaType: VisaSelect) {
    this.visaTypeSubject.next(visaType);
  }
  getVisaType(): VisaSelect {
    return this.visaTypeSubject.getValue();
  }
  //========================================
  private visitReasonSubject = new BehaviorSubject<VisaSelect>(
    {} as VisaSelect
  );
  visitReason$ = this.visitReasonSubject.asObservable();

  setVisitReason(visitReason: VisaSelect) {
    this.visitReasonSubject.next(visitReason);
  }
  getVisitReason(): VisaSelect {
    return this.visitReasonSubject.getValue();
  }
}
